import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/passengers/admin`,
});

const WALLET_API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/wallet/admin`,
});

export async function getAllPassengersWalletByAdmin() {
  try {
    const res = await API.get("/get-all-passengers", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

export async function postPassengersWalletByAdmin(payload) {
  try {
    const res = await API.post("/post-all-passengers", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// ✅ GET A SINGLE PASSENGER'S WALLET BALANCE + TRANSACTIONS (admin view)
// GET /api/wallet/admin/:passengerId
// ════════════════════════════════════════════════════════════════════════════
export async function getPassengerWalletByAdmin(passengerId) {
  try {
    const res = await WALLET_API.get(`/${passengerId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
